import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const ActionableBox = styled(Box)`
    &:hover {
        cursor: pointer;
    }
`;